import gql from 'graphql-tag'
import {
	user as userFragment,
	permissions as permissionsFragment
} from './fragments'

export default gql`
mutation updateManyUsers($idArr: [ID]!, $fields: UserFields!) {
	cashAssist {
		updateManyUsers(idArr: $idArr, fields: $fields) {
			id
			mod_ver
			...usermain
			...permissions
			waiterKey
			cashRegisterId
		}
	}
}
${userFragment}
${permissionsFragment}`

